module.exports = __webpack_public_path__ + "fonts/YogaOT.f20ac0a94f54d521f6b4898291481009.woff2";